import CallbackPage from "../components/reuseableComponents/auth/CallbackPage";
import CypressAuth from "../components/reuseableComponents/auth/CypressAuth";
import HomePage from "../components/public/HomePage";
import NotAuthorized from "../components/reuseableComponents/auth/NotAuthorized";
import RequestPortalAccess from "../components/public/RequestPortalAccess";
import RequestAccess from "../components/public/RequestAccess";
import PortalAccessForm from "../components/public/PortalAccessForm";
import StaffAccessForm from "../components/public/StaffAccessForm";
import WaterSystemHome from "../components/public/WaterSystemHome";
import WaterMonitoringPage from "../components/public/WaterMonitoringPage";

export const publicRoutes = [
  {
    path: "/",
    component: HomePage,
    selectedSystemRouteToItemCode: "HOME"
  },
  {
    path: "/callback",
    component: CallbackPage
  },
  {
    path: "/cypress-auth",
    component: CypressAuth
  },
  {
    path: "/public/request-portal-access",
    component: RequestPortalAccess
  },
  {
    path: "/public/request-access",
    component: RequestAccess
  },
  {
    path: "/public/portal-access-form",
    component: PortalAccessForm
  },
  {  
    path: "/public/staff-access-form",
    component: StaffAccessForm
  },
  {
    path: "/not-authorized",
    component: NotAuthorized
  },
  {
    path: "/water-system-home",
    component: WaterSystemHome,
    requiresWaterSystem: true,
    redirectPath: "/"
  },
  {
    path: "/reports/water-monitoring",
    component: WaterMonitoringPage
  }
];
